import * as React from 'react';
import {FormInput, TextField, DropdownField} from "../static/Inputs";
import {Button} from "../static/Elements";

import compose from 'recompose/compose';
import {withAlert} from 'react-alert';
import createLogger from '../../utils/createLogger';
import connect from "react-redux/es/connect/connect";
import {updateTitle} from "../../data/titles/titleActions";

const DEBUG = true;
const debug = createLogger(DEBUG, `EditTitle.js`);


class EditTitle extends React.Component {

  /* ---------- lifecycle methods ----------*/
  constructor(props) {
    super(props);
    this.state = {
      title: {
        title: this.props.title,
        category: this.props.category,
        exclude: this.props.exclude,
      }
    }
  }

  /* ---------- event handlers ----------*/

  clearState = () => this.setState({
    title: {
      title: ``,
      category: ``,
      exclude: false,
    }
  });

  /* ---------- event handlers ----------*/
  onCancel = () => {
    this.clearState();
    this.props.closeModal();
  };

  onInputChange = (field) => (input) => {
    console.log(`Setting ${field} to ${input}`);

    if (input === "true" || input === "false") {
        input = JSON.parse(input);
    }

    this.setState({
      title: {
          ...this.state.title,
        [field]: input
      }
    });
    console.log(this.state.title);
  };

  onSubmitUpdateTitle = () => {
    const { updateTitle, closeModal, _id, titles, alert } = this.props;
    const {title, category, exclude} = this.state.title;

    let duplicate = false;
    if (exclude === true) {
      for (let t of titles.excludes) {
        if (t.title === title) {
          duplicate = true;
          break;
        }
      }
    }
    if (exclude === false) {
      for (let t of titles.includes) {
        if (t.title === title) {
          duplicate = true;
          break;
        }
      }
    }

    if (duplicate) {
      closeModal();
      alert.info(<p className={`alert-message`}>Title '{title}' already exists; no edits were made</p>)
    } else {
      updateTitle(_id, {...this.state.title});
      closeModal();
      alert.success(<p className={`alert-message`}>Title successfully updated to '{title}' under {category}</p>)
    }
  };


  /* ---------- render ----------*/

  render () {

    const {
      title,
      category,
    } = this.state.title;

    const {
      categories,
      closeModal,
    } = this.props;

    const {
      onInputChange,
      onSubmitUpdateTitle,
    } = this;

    const fieldConfigs = {
      title: {
        value: title,
        name: `update-job-title`,
        label: `Job Title`,
        onChange: onInputChange(`title`),
      },
      category: {
        value: category,
        name: `select-title-category`,
        label: `Category`,
        onChange: onInputChange(`category`),
      }
    };

    const titleTypeConfig = {
      value: title.exclude,
      name: `sort-input`,
      label: `Title Type`,
      className: `margin-right`,
      onChange: onInputChange(`exclude`)
    };

    const canSubmit = (!!title && title !== ``);

    return (
        <div className={`create-lead`}>
          <FormInput>
            <TextField {...fieldConfigs.title}/>
            <DropdownField {...fieldConfigs.category}>
              {
                categories.map((category) => (
                    <option className={"dropdown-item"} key={category} value={category}>{category}</option>
                ))
              }
            </DropdownField>
          </FormInput>
          <footer>
            <Button onClick={closeModal}
                    type="theme-light">
              Cancel
            </Button>
            <Button
                    onClick={onSubmitUpdateTitle}
                    disabled={!canSubmit}>
              Update
            </Button>
          </footer>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
};

export default compose(withAlert,
    connect(mapStateToProps,
        {
          updateTitle,
        })
)(EditTitle)


// WEBPACK FOOTER //
// ./src/components/Titles/EditTitle.js